import { Fragment, type ReactNode } from 'react'

export function Ticker({ items }: { items: ReactNode[] }) {
  const loop = [...items, ...items]
  return (
    <div className="st-ticker">
      <div className="st-ticker-track">
        {loop.map((it, i) => (
          <Fragment key={i}>
            <span>{it}</span>
            <i>●</i>
          </Fragment>
        ))}
      </div>
    </div>
  )
}
